import styled from 'styled-components'


interface ILoader {
    withPadding: boolean;
  }

export const Loader= styled.div<ILoader>`
    padding: ${props => props.withPadding ? "20px 20px" : "0px" } ;
`